import { createContext, ReactNode, useEffect } from 'react'
import { SetURLSearchParams, useSearchParams } from 'react-router-dom'


interface SearchParamsContextType {
    searchParams: URLSearchParams,
    setSearchParams: SetURLSearchParams
}

export const SearchParamsContext = createContext<SearchParamsContextType | null>(null)

export const SearchParamsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        window.multistrikeChartManager?.setSearchParamsMethod(setSearchParams);
        return () => {
            window.multistrikeChartManager?.unsetSearchParamsMethod(setSearchParams);
        }
    }, [setSearchParams])
    return (
        <SearchParamsContext.Provider value={{ searchParams, setSearchParams }}>
            {children}
        </SearchParamsContext.Provider>
    )
}